export const FETCH_MESSAGES_SUCCESS = 'messages/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'messages/FETCH_MESSAGES_FAILURE';

export const ADD_MESSAGE_SUCCESS = 'messages/ADD_MESSAGE_SUCCESS';
export const SEND_MESSAGE_SUCCESS = 'messages/SEND_MESSAGE_SUCCESS';
export const UPDATE = 'messages/UPDATE';